import { connect } from 'react-redux';
import ActivateModal from '../../components/signup/ActivateForm';
import { linkPurchase } from '../../actions/signup';

const mapStateToProps = state => ({
  showCancel: false,
  processing: state.signup.activation.submitting,
  errorTxt: state.signup.activation.error,
});

const mapDispatchToProps = dispatch => ({
  submit: (serial, code) => dispatch(linkPurchase(serial, code)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivateModal);
